import React from "react";
import PostExamUpload from "../components/postExamUpload";

export default function PostExamUploadPage() {
  return <PostExamUpload />;
}
